export default __webpack_public_path__ + "static/media/RemoveFromSchedule.f203181f.svg";